"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumbnailImageViewer = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const Thumbnail_1 = require("./Thumbnail");
const plusBlue_svg_1 = __importDefault(require("../../assets/icons/plusBlue.svg"));
const plusWhite_svg_1 = __importDefault(require("../../assets/icons/plusWhite.svg"));
const ThumbnailContainer = Theme_1.styled.div `
  display: flex;
  overflow: auto;
  padding: 20px;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  color: ${(props) => props.lightBackground ? props.theme.blue : props.theme.white};
  height: 110px;

  ${(props) => props.size &&
    `height: ${Number(props.size) + 60}px; padding: 10px 10px 0px; overflow: auto;`}
`;
const ThumbnailAddButtonContainer = Theme_1.styled.div `
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
`;
const ThumbnailAddButton = Theme_1.styled.div `
  width: ${(props) => (props.size ? `${Number(props.size) - 4}px;` : '92px;')};
  height: ${(props) => (props.size ? `${Number(props.size) - 4}px;` : '92px;')};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;

  &:hover {
    border-color: ${(props) => props.lightBackground ? props.theme.blue : props.theme.white};
  }

  border-style: dashed;
  border-width: ${(props) => (props.size ? '2px;' : '4px;')};
  border-radius: 10%;
  border-color: #ddd;

  svg {
    height: 100%;
    width: 100%;
  }
`;
const ThumbnailLabel = Theme_1.styled.div `
  font-size: 13px;
  margin-top: 0.5em;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  white-space: nowrap;
  width: ${(props) => (props.size ? `${Number(props.size) - 4}px;` : '100px;')};
`;
const AddIcon = Theme_1.styled.img `
  width: ${(props) => (props.size ? '14px;' : '22px;')};
  height: ${(props) => (props.size ? '14px;' : '22px;')};
`;
exports.ThumbnailImageViewer = (props) => {
    function containerClick() {
        props.addImage && props.addImage();
    }
    return (react_1.default.createElement(ThumbnailContainer, Object.assign({}, props),
        props.addImage && (react_1.default.createElement(ThumbnailAddButtonContainer, Object.assign({}, props, { onClick: containerClick }),
            react_1.default.createElement(ThumbnailAddButton, Object.assign({}, props),
                react_1.default.createElement(AddIcon, Object.assign({ src: props.lightBackground ? plusBlue_svg_1.default : plusWhite_svg_1.default }, props))),
            !props.hideLabel && (react_1.default.createElement(ThumbnailLabel, Object.assign({}, props), "Add File")))),
        !!props.images.length &&
            props.images.map((image, index) => (react_1.default.createElement(Thumbnail_1.Thumbnail, Object.assign({}, props, { image: image, key: `thumbnail_${index}` }))))));
};
//# sourceMappingURL=ThumbnailImageViewer.js.map